import { Component } from "react";
import "./index.css";
class NotFound extends Component
{
    render()
    {
        return(
            <div className="notfound-container">
                <img src="https://assets.ccbp.in/frontend/react-js/jobby-app-not-found-img.png" alt="not found" className="not-found-img"/>
                <h1 className="not-found-heading">Page Not Found</h1>
                <p className="not-found-para">We are sorry, the page you requested could not be found.</p>
                <p className="not-found-para">Please go back to the homepage.</p>
            </div>
        );
    }
}

export default NotFound;